 
import { Link } from 'react-router-dom'; 
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit'; import paths from '../../routes/paths' 
import Product from './Product'
import Pagination from '../Common/Pagination'
import {fetchGlobalSearchDetails } from '../../redux/slices/CommonSlice';

const  GlobalSearch = () => { 
  const {searchResults, loading,globalSearchTxt,resultsCurrentPage,resultsTotalPages} = useSelector((state:any) => state.common)
  const dispatch = useDispatch<ThunkDispatch<any,any,any>>();

  const handlePageChange = (page) => {
    const selectedPage = page
    dispatch(fetchGlobalSearchDetails({globalSearchTxt,selectedPage}));
    window.scrollTo(0, 0);
  };
 
  return (
    <div className="page-content bg-light">

      <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
        <div className="container">
          <div className="dz-bnr-inr-entry">
            <h1>Search</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row">
              <ul className="breadcrumb">
                <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                <li className="breadcrumb-item">Search Results</li>
              </ul>
            </nav>
          </div>
        </div>	
      </div>

      <section className="content-inner-3 pt-3 z-index-unset">
        <div className="container-fluid">
          <div className="row">
              <div className="col-80 col-xl-12">
               
              <div className="row">
                <div className="col-12 tab-content shop-" id="pills-tabContent">
                  <div className="tab-pane fade active show" id="tab-list-grid" role="tabpanel" aria-labelledby="tab-list-grid-btn">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                          <div className="row gx-xl-4 g-3">
                            {searchResults && searchResults.map((product,index) => 
                              <Product  key={index} product={product} index={index}/> 
                            )}
                           
                          </div>
                        )}
                  </div>
                </div>
              </div>
              
              <div className="row page mt-0">
                <div className="col-md-6">
                  <p className="page-text">Showing {resultsCurrentPage} Of {resultsTotalPages} Pages</p>
                </div>
                <div className="col-md-6">
                {loading ? (
                      <p>Loading...</p>
                    ) : ( <Pagination
                    currentPage={resultsCurrentPage}
                    totalPages={resultsTotalPages}
                    onPageChange={handlePageChange}
                  />)}
                  {searchResults.length === 0 && 
                    <div className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 m-md-b15 m-b30">
                        <div className="shop-card style-1">No Products.</div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> 
 
    </div> 
  );
}

export default GlobalSearch;

 
